<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        <v-text-field label="Buscar" outlined v-model="search"/>
                        <v-spacer/>
                        <download-excel :data="report" id="btnexcel" name="reporte.xls" hidden :fields="json_fields">
                              Download Data
                            <v-icon right>mdi-file-excel-box</v-icon>
                        </download-excel>
                        <v-btn class="mr-2" color="success" outlined @click="parseTYpe" :loading="reporting">
                            <v-icon left>mdi-microsoft-excel</v-icon>
                            Reporte
                        </v-btn> 
                        <v-btn color="primary" @click="dialog=true">
                            <v-icon left>mdi-account-group</v-icon>
                            Agregar
                        </v-btn> 
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :headers="header" :items="all" :search="search">
                            <template v-slot:item.name="{item}" >
                                <span>{{item.name}} {{item.lastname}}</span>
                            </template>
                            <template v-slot:item.confirm="{item}" >
                                <v-btn icon @click="Confirm(item)" >
                                    <v-icon :color="item.confirm?'primary':'gray'" left>mdi-send</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:item.countFirstEmail="{item}" >
                                <v-btn icon @click="reSend(item)">
                                    <v-icon color="primary" left>mdi-send</v-icon>
                                    {{item.countFirstEmail}}
                                </v-btn>
                            </template>
                            <template v-slot:item.more="{item}" >
                                <v-btn icon @click="moreAction(item)">
                                    <v-icon color="primary" left>mdi-more</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:item.deletes="{item}" >
                                <v-btn icon @click="confirmDelete(item)">
                                    <v-icon color="red" left>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog max-width="900" persistent v-model="dialog">
            <v-card>
                <v-card-title>
                    Registrar Aistente
                    <v-spacer/>
                    <v-btn icon @click="dialog=false">
                        <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <RegisterComponent v-on:closeDialog="closeDialog"/>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="500" v-model="dialogDelete">
            <v-card>
                <v-card-title>
                    <v-spacer/>
                    <v-btn icon color="primary" @click="dialogDelete=false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-alert type="warning">¿Realmente desea eliminar este registro?</v-alert>
                    <strong>Nombre:</strong> {{itemSelect.name}} {{itemSelect.lastname}}
                    <br>
                    <strong>Documento:</strong> {{itemSelect.document}}
                    <br>
                    <strong>Correo electrónico:</strong> {{itemSelect.email}}
                    <br>
                    <strong>Teléfono:</strong> {{itemSelect.phone}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn color="red" class="white--text" :loading="deleting" @click="deleteRegister(itemSelect)">Si, eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent max-width="900" v-model="dialogMore">
            <v-card>
                <v-card-title>
                    <v-spacer/>
                    <v-btn icon @click="dialogMore=false">
                        <v-icon color="red">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6">
                            <strong>¿Es miembro?</strong>
                            <v-radio-group v-model="itemSelect.member" row>
                                <v-radio :value="true" label="Si"></v-radio>
                                <v-radio :value="false" label="No"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" md="12">
                            <strong>¿Tipo de registro?</strong>
                            <v-chip-group column mandatory v-model="itemSelect.typeMember">
                                <v-chip :value="1" filter active-class="primary">'Conferencista'</v-chip>
                                <v-chip :value="6" filter active-class="primary">VIP/ Cortesía</v-chip>
                                <v-chip :value="4" filter active-class="primary">Participante General</v-chip>
                                <v-chip :value="5" filter active-class="primary">Participante General x 1 Día</v-chip>
                                <v-chip :value="3" filter active-class="primary">Modelo de Stand/ Visitante Muestra</v-chip>
                                <v-chip :value="2" filter active-class="primary">Esposa(o)/ Acompañante</v-chip>
                            </v-chip-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <span>Tipo de documento</span>
                            <v-radio-group row v-model="itemSelect.documentType" mandatory>
                                <v-radio value="Cédula de Ciudadanía" label="Cédula de Ciudadanía"></v-radio>
                                <v-radio value="Cédula de Extranjeria" label="Cédula de Extranjeria"></v-radio>
                                <v-radio value="Pasaporte" label="Pasaporte"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="itemSelect.document" label="N° Documento" rounded filled dense/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="itemSelect.name" label="Nombres" rounded filled dense/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="itemSelect.lastname" label="Apellidos" rounded filled dense/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-radio-group row label="Genero" v-model="itemSelect.gender" mandatory>
                                <v-radio value="F" label="F"></v-radio>
                                <v-radio value="M" label="M"></v-radio>
                                <v-radio value="Otro" label="Otro"></v-radio>
                            </v-radio-group>

                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field type="email" label="Correo Electrónico" filled rounded dense v-model="itemSelect.email"/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field label="Teléfono/Celular" type="number" filled rounded dense v-model="itemSelect.phone"/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete :items="countrys" v-model="itemSelect.country" :loading="countring" label="País de residencia" dense filled rounded/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field label="Ciudad de residencia" filled rounded dense v-model="itemSelect.cityPerson"/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field label="Dirección" filled rounded dense v-model="itemSelect.address"/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-checkbox label="No Aplica" v-model="itemSelect.companies"/>
                        </v-col>
                        <v-col cols="12" md="6">

                        </v-col>
                        
                    </v-row>
                    <pre>
                    </pre>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import RegisterComponent from '../../components/RegisterComponent.vue'
import { db } from '../../firebase'
import emailjs from '@emailjs/browser'
export default {
    data: () => ({
        header: [
            {
                text: "Documento",
                align: "start",
                sortable: false,
                value: "document",
            },
            {
                text: "Nombre",
                align: "start",
                sortable: false,
                value: "name",
            },
            {
                text: "Empresa",
                align: "start",
                sortable: false,
                value: "company",
            },
            {
                text: "País",
                align: "start",
                sortable: false,
                value: "country",
            },
            {
                text: "Confirmar",
                align: "start",
                sortable: false,
                value: "confirm",
            },
            {
                text: "Reenviar",
                align: "start",
                sortable: false,
                value: "countFirstEmail",
            },
            {
                text: "Ver",
                align: "start",
                sortable: false,
                value: "more",
            },
            {
                text: "Eliminar",
                align: "start",
                sortable: false,
                value: "deletes",
            }
        ],
        dialog: false,
        search:'',
        dialogDelete:false,
        itemSelect:{
            member:true,
            typeMember:null,
            
            name:null,
            lastname:null,
            documentType:null,
            document:null,
            gender:null,
            country:null,
            cityPerson:null,
            address:null,
            email:null,
            phone:null,

            companies:false,
            company:null,
            jobtitle:null,
            countryCompany:null,
            cityCompany:null,
            addressCompany:null,

            typeInvoice:1,
            nameToInvoice:null,
            documentInvoice:null,
            addressInvoice:null,
            emailInvoice:null,

            languaje:null,
            
            dateAt:null,
            dates:null,

            //si ya esta confirmado
            confirm:false,
            //contar cuantos primeros correos le enviamos
            countFirstEmail:1
        },
        deleting:false,
        dialogMore:false,
        countring:false,
        countrys:[],
        templates:{
            type:null,
            price:null,
            url:null,
            template:null,
            type_url:null,
        },
        json_fields:{
            "Miembro":'miembro',
            "Tipo Miembro":'typeMember',
            "Tipo de documento":'documentType',
            Documento:'document',
            Nombres:"name",
            "Apellidos":"lastname",
            Genero:'gender',
            "Correo Electrónico":"email",
            "Teléfono/Celular":"phone",
            "País de residencia":'country',
            "Ciudad":'cityPerson',
            "Dirección":'address',
            "Compañia":'company',
            "Titulo Laboral":'jobtitle',
            "País (Compañia)":'countryCompany',
            "Ciudad (Compañia)":'cityCompany',
            "Dirección (Compañia)":'addressCompany',
            "A nombre de:":'nameToInvoice',
            "N° Documento de Identificación":'documentInvoice',
            "Dirección de Factura":'addressInvoice',
            "Contacto para pagos (E-mail)":'emailInvoice',
            "Fecha de Registro":'dates',
            


        },
        report:[],
        reporting:false
    }),
    computed: {
        ...mapGetters([
            "all"
        ])
    },
    components: { RegisterComponent },
    methods:{
        closeDialog(){
            this.dialog=false
        
        },
        parseTYpe(){
            
            this.reporting=true

            let miembro= [...this.all]
            
            
                
                let nuevoArray =[]

                miembro.map(x=>{

                    let esmiembro = x.member.toString()

                    let es = ''
                    if(esmiembro=='true'){
                        es='Es miembro'
                        console.log('Es miembro')
                    }

                    if(esmiembro=='false'){
                        es='No es miembro'
                        console.log('No es miembro')
                    }
                    
                    if(x.typeMember == 1){x.typeMember='Conferencista'}
                    if(x.typeMember == 2){x.typeMember='Esposa(o)/ Acompañante'}
                    if(x.typeMember == 3){x.typeMember='Modelo de Stand/ Visitante Muestra'}
                    if(x.typeMember == 4){x.typeMember='Participante General'}
                    if(x.typeMember == 5){x.typeMember='Participante General x 1 Día'}
                    if(x.typeMember == 6){x.typeMember='VIP/ Cortesía'}
                    
                    x.miembro = es
                    nuevoArray.push(x)
                })
                
                this.report = nuevoArray
            
            document.getElementById('btnexcel').click()
            
            this.reporting=false
            
            
        },
        confirmDelete( item ){
            this.itemSelect = item  
            this.dialogDelete=true
        },
        deleteRegister(item){
            this.deleting=true
            console.log(item.email.toString())
            db.collection('assistant').doc(item.email.toString()).delete()
            this.dialogDelete=false
            this.deleting=false
        },
        moreAction(item){
            this.itemSelect= item
            this.dialogMore=true
        },
        fetchCountry(){
            this.countring=true
            this.$http.get('https://restcountries.com/v3.1/all').then(res=>{
                let arreglo = res.data.map(x=>x.name.common)
                this.countrys = arreglo.sort()
                //console.log()
            }).finally(()=>{
                this.countring=false
            })
        },
        async Confirm(item){
            let temple = ''
            if(item.languaje=='true'){
                temple='template_jpo2art'
            }else{
                temple='template_ngfjigr'
            }
            console.log(temple)
            let template= {
                to_name:`${item.name} ${item.lastname}`,
                to_email:item.email

            }
            
            await emailjs.send('service_nx524vd',temple,template,'user_8B00XPfvnqrXGs1La3yQu').then(e=>{
                if(e.status==200){
                this.$toast.success('Email reenviado')

                    this.updateRegister(item)
                     
                }else{
                this.$toast.error('No logramos enviar el correo')
                }
            })
            
        },
        async reSend(item){
             let esmiembro= ''
            item.member? esmiembro='Miembro SLOM':esmiembro='No Miembro SLOM'
            
            if(item.languaje=='false'){
                let typos = await this.$http.get('../Spanish.json')
                if(item.member){
                    let typem = typos.data.members.filter(x=>x.id ==item.typeMember)
                    this.templates.type = typem[0].name
                    this.templates.price = typem[0].price
                    this.templates.url = typem[0].link
                    this.templates.template = typem[0].template
                    this.templates.type_url = typem[0].typeurl
                }else{
                    let typem = typos.data.nomembers.filter(x=>x.id ==item.typeMember)
                    this.templates.type = typem[0].name
                    this.templates.price = typem[0].price
                    this.templates.url = typem[0].link
                    this.templates.template = typem[0].template
                    this.templates.type_url = typem[0].typeurl
                }
                
            }else{

                let typos = await this.$http.get('../English.json')
                if(item.member){
                    let typem = typos.data.members.filter(x=>x.id ==item.typeMember)
                    this.templates.type = typem[0].name
                    this.templates.price = typem[0].price
                    this.templates.url = typem[0].link
                    this.templates.template = typem[0].template
                    this.templates.type_url = typem[0].typeurl
                }else{
                    let typem = typos.data.nomembers.filter(x=>x.id ==item.typeMember)
                    this.templates.type = typem[0].name
                    this.templates.price = typem[0].price
                    this.templates.url = typem[0].link
                    this.templates.template = typem[0].template
                    this.templates.type_url = typem[0].typeurl
                }
            }
            
            let template = {
                to_name:`${item.name} ${item.lastname}`,
                type:this.templates.type,
                price:this.templates.price,
                url:this.templates.url,
                linki:this.templates.url,
                member:esmiembro,
                to_email:item.email,
                type_url:item.type_url
            }
            let count = item.countFirstEmail++
            //console.log(item.countFirstEmail)

            await emailjs.send('service_nx524vd',this.templates.template,template,'user_8B00XPfvnqrXGs1La3yQu').then(e=>{
                if(e.status==200){
                this.$toast.success('Email reenviado')
                    //Actualizar el contador
                    //await db.collection("meetings").doc(id.toString()).update(template, {merge:true})
                    this.updateTemplate(item)
                     
                }else{
                this.$toast.error('No logramos enviar el correo')
                }
            })
            
        },
        async updateTemplate(item){
             
            let template = { countFirstEmail: item.countFirstEmail }
            await db.collection("assistant").doc(item.email.toString()).update(template, {merge:true})      
        },
        async updateRegister(item){
            let template = { confirm: true }
            await db.collection("assistant").doc(item.email.toString()).update(template, {merge:true})      
        }



    },
    created(){
        this.fetchCountry()
    }
}
</script>

<style>

</style>